import React from "react";
import PrintLayout from "./PrintLayout";

export default function FDPrint({ data }) {
  const user = data.userId || {};

  return (
    <PrintLayout>
      <h4>Customer Details</h4>
      <p><b>Name:</b> {user.name}</p>
      <p><b>Account Number:</b> {user.accountNumber}</p>

      <h4 className="mt-3">FD Details</h4>
      <p><b>FD Number:</b> {data.fdNumber}</p>
      <p><b>Amount:</b> ₹ {data.principalAmount}</p>
      <p><b>Interest Rate:</b> {data.interestRate}%</p>
      <p><b>Tenure:</b> {data.tenureMonths} months</p>
      <p><b>Start Date:</b> {new Date(data.startDate).toLocaleDateString()}</p>
      <p><b>Maturity Date:</b> {new Date(data.maturityDate).toLocaleDateString()}</p>
      <p><b>Maturity Amount:</b> ₹ {data.maturityAmount}</p>
    </PrintLayout>
  );
}
